export const Context = [
  {
    title: "Women's Ethnic Wear",

    url: "https://theindiancouture.com/cdn/shop/articles/aefdtbhryjtu_Beautiful_women_in_ethnic_wear_20ce3cb7-ed2f-4791-bacf-a79809db91ec.png?v=1675275656",
  },

  {
    title: "Women's Heels",

    url: "https://ae01.alicdn.com/kf/S90698db16860406c9fe016f1313298a3p/Xibeilove-2023-Summer-Luxury-Women-Sandals-Crystal-Square-Head-Gold-Rhinestone-Snake-Pattern-High-Heels-Wedding.jpg",
  },

  {
    title: " Western Jwellery",

    url: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTKmHA2uTM9nQNnSLkva4TkQM_20Tn7F8i5YcD2ft6q8tQ2LCUYCP2Cb-90LiRwLEit1xY&usqp=CAU",
  },
  {
    title: "Women's fashion",

    url: "https://assets-global.website-files.com/61083e5f5398b157c850d20a/649c47a6eaf50a0e49623f3f_Square%20Blog%20Image%20(1).png",
  },
  {
    title: "Upto 80% Off",
    url: "https://assets.vogue.in/photos/5cff4b8da9f58c977e12730a/1:1/w_1080,h_1080,c_limit/makeup%20stroage.jpg",
  },
];
